import { Component, OnInit, OnDestroy, ChangeDetectorRef, Output, EventEmitter, Input, AfterViewInit, ViewChild } from '@angular/core';
import { ToolsService } from '../../../services/tools.service';
import { Subscription } from 'rxjs';
import { TipModal } from '../../tools/tip-modal/tip-modal.component';
import { TabbingOrderService } from 'modules/foc/services/tabbing-order.service';
import { MessageService } from 'modules/app/services/message.service';

declare var $:any;

@Component({
	selector: 'app-notes',
	templateUrl: './notes.template.html',
	styleUrls: ['./notes.style.scss']
})

export class Notes implements OnInit, OnDestroy, AfterViewInit{

    @ViewChild(TipModal)
    private tipModal: TipModal;
    
    private notesBackToPanelSubscriber: Subscription;
    private focClickEventHandleSubscriber: Subscription;
    singleNote: any; // variable to store the current note's reference
    deleteModalReference: any;
    cancelModalReference: any;
    noteFocusInterval;
    wasLastClickOnParent = false;
    focContainerTouchStartHandler;
    colorValue;
    svgValue;
    sidebarPosition = 'left';
    notesColorToText = {
        "#40D992": "GREEN",
        "#40CAFF": "BLUE",
        "#FFB052": "ORANGE",
        "#E97575": "RED"
    };//map to show all text for colors Add entry in translations (en/es)
    colorChooserOpened = false;// variable to track the chosen color
    quickPinMode: boolean = false; //variable to check whether note is in edit mode so that quickPin modal can be opened on click on book
    quickPositionData: any = null; //variable to temporarily hold position data of click on book to awaiting response quick pin and note modal 
    isFocusNeeded: boolean = false; //variable to check if focus is needed back to notes when delete modal is opened while editing notes 
    isSaveButtonDisabled: boolean = false;

    public imageBasePath: string = IMAGES_BASEPATH;

    notesData: { isLink: boolean; value: string, link?: string }[] = [];
    
    clickTimeout;

    private isCookieBannerVisible: boolean = false;
    private cookieStatusSubscriber: any;

    // function to trigger jump to page in studentbook
	@Output() jumpToPageEventFromNotes : EventEmitter<any> = new EventEmitter<any>();
    
    // function to pin note to page in studentbook
	@Output() pinToPageEvent : EventEmitter<any> = new EventEmitter<any>();

    @Output() quickPinAndSaveNote : EventEmitter<any> = new EventEmitter<any>();
    @Output() addPinOnBookEvent : EventEmitter<any> = new EventEmitter<any>();
    @Output() exitCaptureModeEvent : EventEmitter<any> = new EventEmitter<any>();
    
    // function to remove pin note from page in studentbook
    @Output() removeNotePinEvent : EventEmitter<any> = new EventEmitter<any>();

    // function to edit pin position on page in studentbook
    @Output() moveNotePinEvent : EventEmitter<any> = new EventEmitter<any>();
  
	@Output() deleteNoteEvent : EventEmitter<any> = new EventEmitter<any>();  
	@Output() saveNoteEvent : EventEmitter<any> = new EventEmitter<any>();  
	@Output() updateNoteEvent : EventEmitter<any> = new EventEmitter<any>();  
	@Output() backToNotesPanel : EventEmitter<any> = new EventEmitter<any>();  
	@Output() hideAllNotesTipModals : EventEmitter<any> = new EventEmitter<any>();  
    @Input('notesConfig') inputConfig;
    @Input() currentPage;
    @Input() pinNoteConfig;
    @Input() pageIndex;
    @Input() noteIndex;

    // method to publish hyperlink launch event
    @Output() publishHyperlinkLaunchEvent: EventEmitter<any> = new EventEmitter<any>();

    colorValueArray = ['#40D992', '#40CAFF', '#FFB052', '#E97575'];
    colorSvgArray = ['assets/img/Notes/ColorCircle_green.svg', 'assets/img/Notes/ColorCircle_blue.svg', 'assets/img/Notes/ColorCircle_orange.svg', 'assets/img/Notes/ColorCircle_red.svg'];
    
	constructor(
        private chRef: ChangeDetectorRef,
        public toolsService: ToolsService,
        public tabbingOrderService: TabbingOrderService,
        private readonly messageService: MessageService
    ) {
        this.textAreaKeyDownHandler = this.textAreaKeyDownHandler.bind(this);
        this.textAreaKeyUpHandler = this.textAreaKeyUpHandler.bind(this);
        this.textAreaClickHandler = this.textAreaClickHandler.bind(this);
        this.textAreaPasteHandler = this.textAreaPasteHandler.bind(this);
        this.textAreaChangeHandler = this.textAreaChangeHandler.bind(this);
        this.textAreaMouseDownHandler = this.textAreaMouseDownHandler.bind(this);
     }

    ngAfterViewInit(): void {

        let that = this;
        
        // need this setTimeout to add scrollbar to note in notes panel. Chref change detect does not work. 
        setTimeout(() => {
            this.addScrollToNote(this.singleNote.querySelector('textarea'));
            this.addScrollToNote(this.singleNote.querySelector('highlighted-text'));
        }, 50);

        // do not give artificial focus to note when editing.
        // if(this.isCurrentNoteActive()) {
        //     this.noteFocusInterval = setInterval(function() {
        //         // that.singleNote.querySelector('textarea').focus();
        //     },100);
        // }

        this.focContainerTouchStartHandler = this.focContainerTouchstartFunction.bind(this);
        $('.foc-container').on('touchstart', this.focContainerTouchStartHandler);
        $('.foc-container .notes-container')
            .on('show.bs.dropdown', '#colorChooser', function () {
                that.colorChooserOpened = true;
                that.chRef.detectChanges();
            })
            .on('hide.bs.dropdown', '#colorChooser', function () {
                that.colorChooserOpened = false;
                that.chRef.detectChanges();
            });

        //Focus on note
        if (this.inputConfig.data.isNewlyAdded) {
            let noteTextArea = this.singleNote.querySelector('textarea');
            if (this.isIosDevice() && window.innerWidth < 576) {
                noteTextArea.focus();
                setTimeout(()=> {
                    // do not give artificial focus to note when editing.
                    if(document.activeElement.tagName == "TEXTAREA" && this.inputConfig.data.mode == 'editing') {
                        if(this.inputConfig.data.viewOnMobile){
                            setTimeout(() => {
                                this.singleNote.parentNode.classList.add('focus-on-device');
                            });
                        }
                        this.quickPinMode = true;
                        this.quickPinAndSaveNote.emit(JSON.parse(JSON.stringify(this.inputConfig)));
                    }
                },100);
            } else if (this.isIosDevice() && window.innerWidth >= 576) {
                this.focusAndOpenKeyboard(noteTextArea, 100); // or without the second argument
            } else {
                setTimeout(() => {
                    noteTextArea.focus();
                    this.quickPinMode = true;
                    this.quickPinAndSaveNote.emit(JSON.parse(JSON.stringify(this.inputConfig)));
                });
            }
        }
    }

    focClickEventHandler(e) {
        let noteComponent = this.singleNote.parentNode.parentNode;
        if (this.inputConfig.data.mode == 'editing' && !noteComponent.contains(e.target)) {
            let readerContainerWrapper = document.querySelector("#reader-container-wrapper");
            let addNoteButton = document.querySelector('.add-note-button');
            let textArea = this.singleNote.querySelector('textarea');

            if (this.inputConfig.data.isNewlyAdded) {
                if (!textArea.value.trim() && !addNoteButton.contains(e.target)) {
                    this.deleteNote();
                } else if (readerContainerWrapper.contains(e.target) && textArea.value.trim() || textArea.value.trim()) {
                    this.saveNote();
                }
            } else {
                if (!textArea.value.trim() && !addNoteButton.contains(e.target)) {
                    $(`#deleteSingleNoteModal-${this.inputConfig.selector}`).modal('show');
                } else if (readerContainerWrapper.contains(e.target) && textArea.value.trim() || textArea.value.trim()) {
                    this.saveNote();
                }
            }

        }
    }

    isIosDevice() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].indexOf(navigator.platform) > -1
          // iPad on iOS 13 detection
          || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

	ngOnInit() {
        this.initializeNotes();

        // subscribe to observable when the toc position is changed and update accordingly.
        this.notesBackToPanelSubscriber = this.toolsService.sidebarConfigChangeObservable$.subscribe((sidebarConfig) => {
            this.updateSidebarPosition(sidebarConfig.position);
        });

        // subscribe to observable when the .foc-container click event fires and handle accordingly.
        this.focClickEventHandleSubscriber = this.toolsService.focContainerClickEventDataObservable$.subscribe((eventData) => {
            this.focClickEventHandler(eventData);
        });

        // Check if cookie banner is visible
        const cookieBanner = document.getElementsByClassName('cookies-banner');
        this.isCookieBannerVisible = !!cookieBanner?.[0];

        // Subscribe to cookie status and adjust the tooltip of pdf hotspot
        this.cookieStatusSubscriber = this.messageService.getChannelObservable('cookieStatus').subscribe((res: any) => {
            this.isCookieBannerVisible = res.data?.enabled;
        });
	}

    showUrlTipModal(bnds, link='') {
        let viewWidth = window.innerWidth || document.documentElement.clientWidth;
        let viewHeight = (window.innerWidth || document.documentElement.clientWidth) - document.querySelector('#toolbar-wrapper-id').getBoundingClientRect().height;

        // Cookie banner component
        const cookieBanner = document.getElementsByClassName('cookies-banner');

        // Check if the sidebar is on the left side
        const sidebarLeft = this.sidebarPosition === 'left';

        let position = {
            top: (bnds.top + (bnds.height / 2)) + 24 - (this.isCookieBannerVisible ? cookieBanner[0].getBoundingClientRect().height : 0),
            left: sidebarLeft && (bnds.left + (bnds.width / 2)) - 30,
            right: !sidebarLeft && Math.abs(bnds.right - viewWidth) + (bnds.width / 2) - 30,
            position: 'fixed'
        }

        if (bnds.top >= 0 && bnds.left >= 0 && bnds.right <= (viewWidth) && bnds.bottom <= (viewHeight)) {
            this.tipModal.showTipModal('URL', position, link);
        } else {
            return;
        }
    }

    handleMouseOver(event, part) {
        const bnds = event.target.getBoundingClientRect();
        this.showUrlTipModal(bnds, part.value);
    }

    handleMouseOut() {
        this.tipModal.hideTipModal('URL');
    }

    handleHyperlinks(textarea: HTMLTextAreaElement) {
        const text = textarea.value;
        if (typeof text !== "string") {
            console.error("Invalid input: text must be a string", text);
            return;
        }

        const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/i;
        this.notesData = [];

        // Show/hide textarea based on presence of links
        if (!urlRegex.test(text)) {
            textarea.style.display = "block";
            const existingDiv = textarea.parentNode?.querySelector(".highlighted-text");
            if (existingDiv) existingDiv.remove();
            return;
        } else {
            textarea.style.display = "none";
            const existingDiv: HTMLElement = textarea.parentNode?.querySelector(".highlighted-text");
            if (existingDiv) existingDiv.style.display = "block";
        }

        // Step 1: Split text into lines using '\n'
        const lines = text.split("\n");



        // Step 2: Process each line separately
        this.notesData = lines.reduce((acc, line, index) => {
            const parts = line.split(urlRegex).filter(p => p.length > 0);
    
            parts.forEach(part => {
                const isLink = urlRegex.test(part);
                if (isLink) {
                    // Insert line break before link (unless it's the first element)
                    if (acc.length > 0 && acc[acc.length - 1]?.value !== "\n") {
                        acc.push({ isLink: false, value: "\n" });
                    }
                    acc.push({
                        isLink: true,
                        value: part,
                        link: part.toLowerCase().startsWith("www.") ? "https://" + part : part
                    });
                    // Line break after link
                    acc.push({ isLink: false, value: "\n" });
                } else {
                    acc.push({ isLink: false, value: part });
                }
            });
    
            // Add line break if not already added
            if (index < lines.length - 1 && acc[acc.length - 1]?.value !== "\n") {
                acc.push({ isLink: false, value: "\n" });
            }
    
            return acc;
        }, [] as { isLink: boolean; value: string; link?: string }[]);
    } 

    openLink(url: string) {
        // Delay to check if a double-click event happens
        this.clickTimeout = setTimeout(() => {
          if (this.inputConfig.data.mode !== "editing") {
            this.publishHyperlinkLaunchEvent.emit(url);
            window.open(url, "_blank");
          }
        }, 250); // Small delay to differentiate between click & dblclick
      }
      
    handleDoubleClick() {
        // If double-click happens, cancel the single click action
        if(this.clickTimeout)
            clearTimeout(this.clickTimeout);
      }
      
	// main function to initialize the modal.
	initializeNotes() {

        // marking the note to be newly created
        this.inputConfig.data.isNewlyAdded = true;
        this.inputConfig.data.dataRecievedFromServer = false;

        this.chRef.detectChanges();

        this.singleNote = document.querySelector('#single-note-'+this.inputConfig.selector);
        this.svgValue = this.inputConfig.data.svg;
        this.colorValue = this.inputConfig.data.color;
        this.setNotesColor(this.colorValueArray.indexOf(this.inputConfig.data.color));

        this.deleteModalReference = document.querySelector('#deleteSingleNoteModal-'+this.inputConfig.selector).querySelector('.modal-content');
        this.cancelModalReference = document.querySelector('#cancelSingleNoteModal-'+this.inputConfig.selector).querySelector('.modal-content');
        
        if(this.inputConfig.data.data && this.inputConfig.data.data != "") {
            this.singleNote.querySelector('textarea').value = this.inputConfig.data.data;
            
            // marking the note to be already existing if the note data was present in input config
            this.inputConfig.data.isNewlyAdded = false;
            this.inputConfig.data.dataRecievedFromServer = true;

            this.saveNote({ calledFromInitNotes: true });
        } else {
            this.toolsService.setNoteStatus(true);
            this.toolsService.setActiveNoteReference(this);
        }

        var textArea =  this.singleNote.querySelector('textarea');
        this.addScrollToNote(textArea);
        textArea.addEventListener('keydown', this.textAreaKeyDownHandler);
        textArea.addEventListener('keyup', this.textAreaKeyUpHandler);
        textArea.addEventListener('click', this.textAreaClickHandler);
        textArea.addEventListener('paste', this.textAreaPasteHandler);
        textArea.addEventListener('change', this.textAreaChangeHandler);
        textArea.addEventListener('input', this.textAreaChangeHandler);
        textArea.addEventListener('mousedown', this.textAreaMouseDownHandler, false);


        if(this.inputConfig.data.viewOnMobile) {
            this.toolsService.setSingleNoteReference(this);
        }

        // set position for each time the note is initialized.
        this.updateSidebarPosition(this.toolsService.getSidebarConfigUpdated().position);

        let dropDownItem: any = document.querySelectorAll('.dropdown-item');
        if (document.documentElement.lang == 'es') {
            for (let i = 0; i < dropDownItem.length; i++) {
                dropDownItem[i].style.padding = "0.8rem 1rem";
            }
        }
    }

    focusAndOpenKeyboard(el, timeout=100) {
        if (el) {
            // Align temp input element approximately where the input element is
            // so the cursor doesn't jump around
            let __tempEl__ = document.createElement('input');
            __tempEl__.style.position = 'absolute';
            __tempEl__.style.top = (el.offsetTop + 7) + 'px';
            __tempEl__.style.left = el.offsetLeft + 'px';
            __tempEl__.style.height = '0';
            __tempEl__.style.opacity = '0';
            // Put this temp element as a child of the page <body> and focus on it
            document.body.appendChild(__tempEl__);
            __tempEl__.focus();

            // The keyboard is open. Now do a delayed focus on the target element
            setTimeout(() => {
                el.focus();
                el.click();
                // Remove the temp element
                document.body.removeChild(__tempEl__);
                this.quickPinMode = true;
                this.quickPinAndSaveNote.emit(JSON.parse(JSON.stringify(this.inputConfig)));
            }, timeout);
        }
    }

    // event listener for keydown event on note. used for note autoresize.
    textAreaKeyDownHandler(event) {

        this.chRef.detectChanges();
        const textarea = event.target;
        this.addScrollToNote(textarea);

    }

    // event listener for keyup event on note. used for tick button handling and note autoresize.
    textAreaKeyUpHandler(event) {
        
        this.chRef.detectChanges();
        var textArea:any = event.target;

        this.addScrollToNote(textArea);
        
        let saveNoteBtn = this.singleNote.querySelector('.save-note');
        if(saveNoteBtn){
            if(textArea.value.trim() == "") {
                saveNoteBtn.classList.add('disabled');
                this.isSaveButtonDisabled = true;
            } else {
                saveNoteBtn.classList.remove('disabled');
                this.isSaveButtonDisabled = false;
            }
        }

    }

    textAreaClickHandler(event) {
        // placeholder function
    }

    textAreaPasteHandler(event) {
        if(this.singleNote.querySelector('.save-note')) {
            this.singleNote.querySelector('.save-note').classList.remove('disabled');
            this.isSaveButtonDisabled = false;
        }

        setTimeout(()=> {
            const textarea = this.singleNote.querySelector('textarea');
            this.addScrollToNote(textarea);
        })
    }

    textAreaChangeHandler(event) {
        if (event.target.value.trim() == "" && this.singleNote.querySelector('.save-note')) {
            this.singleNote.querySelector('.save-note').classList.add('disabled');
            this.isSaveButtonDisabled = true;
        }
    }

    textAreaMouseDownHandler(event) {
        if (event.detail > 1) {
            event.preventDefault();
        }
    }

    addScrollToNote(noteElement: HTMLElement) {
        // if note element is not found then return.
        if(!noteElement) {
            return;
        }

        // set element height to 1px to get correct scroll height every time.
        if (noteElement.style.display !== "none")
            noteElement.style.height = '1px';

        // add scroll after 5 lines
        if (noteElement.clientHeight < noteElement.scrollHeight) {
            if (noteElement.scrollHeight < 96) {
                noteElement.style.height = (noteElement.scrollHeight + 10) + 'px';
            } else {
                noteElement.style.height = (96) + 'px';
            }
        }

        if (noteElement.scrollHeight > 96) {
            noteElement.style.overflow = 'auto';
        }

        setTimeout(() => {
            if (!this.isCurrentNoteActive()) {
                noteElement.scrollTop = noteElement.scrollHeight;
                noteElement.scrollTo(0, noteElement.scrollHeight);
            }
        }, 100);
    }


    // onDestroy Event Hook.
	ngOnDestroy(): void {

        if(this.isCurrentNoteActive()) {
            this.autoSaveAndCloseNote();
        }

        if(!this.inputConfig.data.dataRecievedFromServer) {
            this.toolsService.setNoteStatus(false);
            this.toolsService.setActiveNoteReference(undefined);
        }

        this.toolsService.removeNotefromNotesMap(this.inputConfig.data.id);
        if(this.inputConfig.data.viewOnMobile) {
            this.toolsService.removeSingleNoteReference();
        }

        this.tipModal.hideTipModal('NOTES');

        $('.foc-container').off('touchstart', this.focContainerTouchStartHandler);
        this.removeSelectedNoteMode(this.inputConfig.data.id);
        this.notesBackToPanelSubscriber.unsubscribe();
        this.focClickEventHandleSubscriber.unsubscribe();
        //Color paletes choser handler are destroyed
        $('.foc-container .notes-container')
            .off('show.bs.dropdown hide.bs.dropdown', '#colorChooser'); 
            
        var textArea =  this.singleNote.querySelector('textarea');
        textArea.removeEventListener('keydown', this.textAreaKeyDownHandler);
        textArea.removeEventListener('keyup', this.textAreaKeyUpHandler);
        textArea.removeEventListener('click', this.textAreaClickHandler);
        textArea.removeEventListener('paste', this.textAreaPasteHandler);
        textArea.removeEventListener('change', this.textAreaChangeHandler);
        textArea.removeEventListener('input', this.textAreaChangeHandler);
        textArea.removeEventListener('mousedown', this.textAreaMouseDownHandler);
    }
    
    // set the notes color.
    setNotesColor(index, event?) {

        // if index is undefined or -ve or more than possible then set to 0 else use the index value.
        index = index == undefined ? 0 : index < 0 ? 0 : index > this.colorValueArray.length - 1 ? 0 : index;
        this.singleNote.style.borderColor = this.colorValueArray[index];
        this.colorValue = this.colorValueArray[index];
        this.svgValue = this.colorSvgArray[index];
        if(this.singleNote.classList.contains('selected-note'))
            this.singleNote.style.boxShadow = '0 2px 24px -6px rgba(0,0,0,0.5), 0 2px 24px -6px ' +  this.colorValue +"B3";
        else
            this.singleNote.style.boxShadow = '';

        if(event){
            event.stopPropagation();
            $('.notes-color-dropdown').dropdown('toggle');
        }
        this.rotateColorsArray(this.colorValue);
    }

    // delete the note component.
    deleteNote() {
        this.quickPinMode = false;
        if(this.pinNoteConfig.isCaptureMode && this.pinNoteConfig.selectedNote === this.inputConfig.data.id) {
            this.exitCaptureMode();
        }
        this.inputConfig.data.mode = 'saved';
        this.toolsService.setNoteStatus(false);
        this.toolsService.setActiveNoteReference(undefined);
        

        this.deleteNoteEvent.emit(this.inputConfig);
    }

    // save a note so it cant be edited furthur.
    saveNote({
        calledFromInitNotes = false,
        calledFromQuickSave = false,
        calledFromSaveBtn = false
    } = {}) {
        // this.quickPinMode = false
        // Find and implement for common code function.

        let hasDataChanged = true;
        if ((this.inputConfig.data.data === this.singleNote.querySelector('textarea').value)
            && (this.inputConfig.data.color === this.colorValue) && !calledFromQuickSave) {
                hasDataChanged = false;
        }
       
        this.inputConfig.data.data = this.singleNote.querySelector('textarea').value;
        this.inputConfig.data.color = this.colorValue;
        this.inputConfig.data.svg = this.svgValue;

        this.commonSaveNoteCode();
        
        if(this.inputConfig.data.viewOnMobile) {
            setTimeout(() => {
                this.singleNote.querySelector('textarea').blur();
                this.singleNote.parentNode.classList.remove('focus-on-device');
            });
        }

        if(!this.inputConfig.data.viewOnMobile && this.inputConfig.data.isNewlyAdded && !calledFromInitNotes && !calledFromQuickSave) {

            this.hideAllNotesTipModals.emit();
            this.tipModal.showTipModal('NOTES');
        }

        if(hasDataChanged && !calledFromInitNotes) {
            let action = this.inputConfig.data.isNewlyAdded ? "created" : "edited";
            this.xapiUpdateEvent(action);
        }
        if(calledFromSaveBtn){
            setTimeout(() => {
                const kebabMenuButton = $(`#dropdownMenuButton-${this.inputConfig.selector}`)[0];
                kebabMenuButton && $(kebabMenuButton).focus();
            });
        }

        // Handle hyperlinks after saving/loading
        this.handleHyperlinks(this.singleNote.querySelector('textarea'));
    }

    openDeleteModal(){
        $('#deleteSingleNoteModal-'+this.inputConfig.selector).modal();
        this.isFocusNeeded = true
        if(this.isIosDevice() && window.innerWidth < 576){
            this.singleNote.querySelector('textarea').blur();
        }
        this.setFocusOnDeleteNoteModal('deleteSingleNoteModalCloseButton-' + this.inputConfig.selector);
    }

    closeDeleteModal(){
        $('#deleteSingleNoteModal-'+this.inputConfig.selector).modal('hide');
        //NEMO 19646: focusEl is the element to be focused after the modal is closed it can be either the delete(trash icon) or the kebab button(which opens dropdown having delete button)
        let focusEl = (document.getElementById("singleNoteActiveDeleteBtn-" + this.inputConfig.selector)) || document.getElementById("dropdownMenuButton-" + this.inputConfig.selector);
        if(!focusEl && this.isFocusNeeded){
            this.isFocusNeeded = false;
            focusEl = this.singleNote.querySelector('textarea');
        }
        //A delay is added to because the focus state was not being set properly on the element
        setTimeout(() => {
            focusEl && focusEl.focus();
        });
        
    }

    // handling for jump to page. also creates a new note in case of mobile.
    jumpToPage() {
        this.jumpToPageEventFromNotes.emit(JSON.parse(JSON.stringify(this.inputConfig.data)));
    }

    // handling for note pin events.
    notePinHandler(emitter) {
        if(this.toolsService.getNoteStatus()) {
            return;
        }
        this.toolsService.setNoteStatus(true);
        this.toolsService.setActiveNoteReference(this);
        emitter.emit(JSON.parse(JSON.stringify(this.inputConfig)));
    }

    exitCaptureMode() {
        this.exitCaptureModeEvent.emit(JSON.parse(JSON.stringify(this.inputConfig)));
    }

    backToEditNotes() {
        this.singleNote.querySelector('textarea').focus();
        this.quickPositionData = null;
        if(this.quickPinMode){
            this.quickPinAndSaveNote.emit(JSON.parse(JSON.stringify(this.inputConfig)));
        }
    }

    quickSaveAndPin() {
        this.inputConfig.data.pinPosition = this.quickPositionData
        this.quickPositionData = null;
        this.saveNote({ calledFromQuickSave:true });
        this.addPinOnBookEvent.emit([JSON.parse(JSON.stringify(this.inputConfig))]);
    }


    // double click on saved note to enable editing.
    doubleClickOnNotes(event=null) {
        if(this.inputConfig.data.mode == 'editing') {
            return;
        }

        if(this.toolsService.getNoteStatus()) {
            return;
        }

        if(event){
            event.stopPropagation();
        }

        const highlightText = this.singleNote.querySelector('.highlighted-text');
        if (highlightText) {
            highlightText.style.display = "none";
            this.singleNote.querySelector('textarea').style.display = "block";
            this.addScrollToNote(this.singleNote.querySelector('textarea'));
        }

        this.editNote();
    }

    // single click on saved note and its pin to toggle between selected-deselected mode.
    addSelectedNoteMode(noteId, forceAdd = false, fromPinNote=false) {
        if(noteId == this.toolsService.getSelectedNoteId() && !forceAdd){
            return;
        }
        if (window.innerWidth > 576) {
            this.removeSelectedModeFromAllNotes();
            let noteHotspot = $(`[note-id='${noteId}']`);
            if (noteHotspot) {
                noteHotspot.addClass("noteSelected");
            }
            // adding settimeout because for some reason ondestory was being called while pinning the note and thus no note was found to add the respective classes
            // onDestroy called beacause the notesConfig prop of the noteComponent is updated with pin position, thus component is reinitialised by angular
            let noteComponent: any = document.querySelector('#single-note-' + noteId);
            if (fromPinNote) {
                setTimeout(() => {
                    $('#single-note-' + noteId).css('box-shadow' , '0 2px 24px -6px rgba(0,0,0,0.5), 0 2px 24px -6px ' + this.colorValue + "B3");
                    $(`[note-id='${noteId}']`).addClass("noteSelected");
                }, 400);
            } else {
                setTimeout(() => {
                    noteComponent.scrollIntoView({ behavior: "smooth", block: 'nearest' });
                }, 400);
                noteComponent.classList.add('selected-note');
                noteComponent.style.boxShadow = '0 2px 24px -6px rgba(0,0,0,0.5), 0 2px 24px -6px ' + this.colorValue + "B3";
                $(`[note-id='${noteId}']`).addClass("noteSelected");
            }
            this.toolsService.setSelectedNoteId(noteId);
        }
    }
    removeSelectedNoteMode(noteId) {
        let noteComponent:any = document.querySelector('#single-note-'+noteId);
        if(!this.pinNoteConfig.sideBarToggleForPinNote){
            $(`[note-id='${noteId}']`).removeClass("noteSelected");
        }
        if (noteComponent && noteComponent.classList.contains('selected-note')) {
            noteComponent.classList.remove('selected-note');
            noteComponent.style.boxShadow = '';
        }
        if(noteId == this.toolsService.getSelectedNoteId()){
            this.toolsService.removeSelectedNoteId();
        }
    }   
    removeSelectedModeFromAllNotes() {
        let map = this.toolsService.getNoteReferenceMap();
        Object.keys(map).forEach((note)=>{
            this.removeSelectedNoteMode(note);
        })
    }

    // set note to editing mode.
    editNote() {
        this.inputConfig.data.data = this.singleNote.querySelector('textarea').value;
        this.inputConfig.data.mode = 'editing';
        this.inputConfig.data.wasNoteEdited = true;
        this.toolsService.setNoteStatus(true);
        this.toolsService.setActiveNoteReference(this);
        this.inputConfig.data.isNewlyAdded = false;
        this.inputConfig.data.dataRecievedFromServer = false;
        
        this.chRef.detectChanges();
        
        this.singleNote.querySelector('.save-note').classList.remove('disabled');
        this.isSaveButtonDisabled = false;
        this.singleNote.querySelector('textarea').readOnly = false;

        // issue 1234(cursor to be at the end on focus of textarea) fix 
        let textarea = this.singleNote.querySelector('textarea');
        let end = textarea.value.length;
        textarea.setSelectionRange(end, end);
        textarea.focus();

        setTimeout(()=> {
            // do not give artificial focus to note when editing.
            if(this.inputConfig.data.viewOnMobile && document.activeElement.tagName == "TEXTAREA" && this.inputConfig.data.mode == 'editing') {
                setTimeout(() => {
                    this.singleNote.parentNode.classList.add('focus-on-device');
                });
            }
        },100);

        if(!this.inputConfig.data.pinPosition){
            this.quickPinMode = true;
            this.quickPinAndSaveNote.emit(JSON.parse(JSON.stringify(this.inputConfig)));
        }
    }

    // return the data stored in this note.
    getNoteData() {
        return this.inputConfig;
    }

    // return if note is active i.e opened in editing mode.
    isCurrentNoteActive() {
        return this.inputConfig.data.mode == 'editing';
    }

    // Move current note to notes panel ( only for mobile ).
    // Deletes current note on stdbook and creates new in panel.
    goBackToNotesPanel() {
        this.backToNotesPanel.emit(this.inputConfig);
    }

    // Update the note's value and color with current values from config. Called from studentbook when note is sent back to panel.
    // This is required as the data in config is not bound in template.
    updateNote() {
        this.singleNote.querySelector('textarea').value = this.inputConfig.data.data;
        this.setNotesColor(this.colorValueArray.indexOf(this.inputConfig.data.color));
    }

    rotateColorsArray(color) {

        let index = this.colorValueArray.indexOf(color);

        for( var i=0; i < index; i++ ) {
            this.colorSvgArray.push(this.colorSvgArray.shift());
            this.colorValueArray.push(this.colorValueArray.shift());
        }

    }

    textAreaFocusEvent() {

        clearInterval(this.noteFocusInterval);

        if(this.inputConfig.data.viewOnMobile && document.activeElement.tagName == "TEXTAREA" && this.inputConfig.data.mode == 'editing') {
            setTimeout(() => {
                this.singleNote.parentNode.classList.add('focus-on-device');
            });
        }
    }

    textAreaBlurEvent() {

        if(this.wasLastClickOnParent && this.inputConfig.data.mode == 'editing' && !this.isFocusNeeded) {
            this.singleNote.querySelector('textarea').focus();
            if(this.inputConfig.data.viewOnMobile && document.activeElement.tagName == "TEXTAREA" && this.inputConfig.data.mode == 'editing') {
                setTimeout(() => {
                    this.singleNote.parentNode.classList.add('focus-on-device');
                });
            }            
        } else {
            
            // NEMO-7429 hack for
            // NEMO-7676 : [eReader] Difficulty in editing a note on mobile device landscape
            if (window.navigator && window.navigator.userAgent) {
                let agent = window.navigator.userAgent;
                let start = agent.indexOf("OS");
                let version;
    
                if (agent.indexOf("iPhone") > -1 && start > -1) {
                    version = agent.substr(start + 3, 3).replace("_", ".");
                    if (version.indexOf("13") == 0) {
                        window.scrollTo(0,0);
                    }
                }
    
            }
        	
            if(this.inputConfig.data.viewOnMobile) {
                setTimeout(() => {
                    this.singleNote.parentNode.classList.remove('focus-on-device');
                });
            }
        }

    }

    isNoteParent(element) {
        let isParent = false;
        if(this.inputConfig.data.viewOnMobile == false) {
            return false;
        }
        while(element && element.parentNode) {
            if(element == this.singleNote || element == this.deleteModalReference || element == this.cancelModalReference ) {
                isParent = true;
            }
            element = element.parentNode;
        }
        return isParent;

    }

    focContainerTouchstartFunction() {
        this.wasLastClickOnParent = false;
        if(this.isNoteParent(event.target)) {
            this.wasLastClickOnParent = true;
            this.singleNote.querySelector('textarea').blur();
        } else {
            this.wasLastClickOnParent = false;
            this.singleNote.querySelector('textarea').blur();
        }
    }

    saveLastStateofNote() {

        this.singleNote.querySelector('textarea').value = this.inputConfig.data.data;
        this.setNotesColor(this.colorValueArray.indexOf(this.inputConfig.data.color));
        this.commonSaveNoteCode();

        
    }

    cancelNote() {

        if(this.inputConfig.data.data == "") {
            this.deleteNote();
        } else {
            this.saveLastStateofNote();
        }

    }

    commonSaveNoteCode() {
        if(this.singleNote.querySelector('.save-note')) {
            this.singleNote.querySelector('.save-note').classList.add('disabled');
            this.isSaveButtonDisabled = true;
        }

        if(!this.inputConfig.data.dataRecievedFromServer) {
            this.toolsService.setNoteStatus(false);
            this.toolsService.setActiveNoteReference(undefined);
        }

        this.inputConfig.data.mode = 'saved';
        this.singleNote.querySelector('textarea').readOnly = true;
        this.saveNoteEvent.emit(this.inputConfig);
        if(!this.pinNoteConfig.sideBarToggleForPinNote){
            this.exitCaptureMode();
        }

        if(!this.inputConfig.data.viewOnMobile) {
            this.toolsService.addNoteToNotesMap(this.inputConfig.data, this);
        }
    }

     updateSidebarPosition(position) {
        this.sidebarPosition = position || 'left';
    }

    autoSaveAndCloseNote() {

        if(this.singleNote.querySelector('textarea').value.trim() == '') {
            if(this.inputConfig.data.wasNoteEdited) {
                this.saveLastStateofNote();
            } else {
                this.deleteNote();
            }
        } else {
            this.saveNote();
        }

    }

    getLatestNotesConfig() {

        let config = this.inputConfig;
        config.data.data = this.singleNote.querySelector('textarea').value;
        config.data.color = this.colorValue;
        config.data.svg = this.svgValue;
        config.data.mode = 'saved';

        return config;
    }


    /**
     * This function should only be called from save note event and delete event.
     * Edit and update will either save or auto save eventually.
     * Edit and delete will be covered in delete.
     */

    xapiUpdateEvent(action) {
        this.updateNoteEvent.emit({action:action, data:this.inputConfig});
    }

    hideTipModal() {
        this.tipModal.hideTipModal('NOTES');
    }

    /**
     * This function is used to handle keyboard events for close and delete button
     * - If tab is pressed on delete button, focus should go on close button
     * - If shift+tab is pressed on close button, focus should go on delete button
     * @param event - Keyboard event
     * @param button - button name
     */
    handleKeyDown(event:any , button:string, selector:string) {
        const closeBtn = document.getElementById('deleteSingleNoteModalCloseButton-' + selector);
        const deleteBtn = document.getElementById('deleteSingleNoteModalDeleteButton-' + selector);
        if (event.key === 'Tab') {
            switch (button) {
                case 'deleteBtn':
                    if(!event.shiftKey) {
                        event.preventDefault();
                        closeBtn.focus();
                    }
                    break;
                case 'closeBtn':
                    if(event.shiftKey) {
                        event.preventDefault();
                        deleteBtn.focus();    
                    }
                    break;
                }
        }
    }

    /**
     * This function is used to focus on the delete modal when it is opened
     * @param modalId - Id of the modal to focus on
     */

    setFocusOnDeleteNoteModal(modalId: string) {
        setTimeout(() => {
            let deleteModal = document.getElementById(modalId);
            if (deleteModal) {
                deleteModal.focus();
            }
        }, 500); // Delay the focus operation by 500 milliseconds as the modal takes time to appear
    }

    /**
     * This function is used to handle the escape key press event
     * - If escape key is pressed, close the note delete modal
     * @param event - Keyboard event
     */
    handleEscapeKey(event: KeyboardEvent): void {
        if (event.key === 'Escape') {
            this.closeDeleteModal();
        }
    }
}